import { h } from 'preact';
import * as BaseComp from 'components/shared/cookies/cookies.js';
import { accessNested } from 'utils/utils';
// import s from 'components/shared/cookies/cookies.sss';

export default class Cookies extends BaseComp.default {
	constructor(props) {
		super(props);

		const useTealiumCookieConsent = accessNested(props, 'appData.options.enableTealiumCookieConsent');
		const useEnsightenCookieConsent = accessNested(props, 'appData.options.enableEnsighten');

		if (this.show && (useTealiumCookieConsent || useEnsightenCookieConsent)) {
			this.show = false;
		}
	}
}
